import type { BookingResource } from "./clientPortalApi";
import type { ServiceChoice } from "./portalPresentation";

function normalize(value: string): string {
  return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase("cs-CZ");
}

export function matchesPortalSearch(query: string, values: Array<string | null | undefined>): boolean {
  const text = normalize(values.filter(Boolean).join(" "));
  return normalize(query).trim().split(/\s+/).every((word) => text.includes(word));
}

export function matchesServiceSearch(choice: ServiceChoice, query: string): boolean {
  return matchesPortalSearch(query, [
    choice.service.name,
    choice.service.description,
    choice.portalName,
    ...choice.service.resources.flatMap((resource) => [resource.name, resource.location]),
  ]);
}

export function matchesResourceSearch(resource: BookingResource, choices: ServiceChoice[], query: string): boolean {
  return matchesPortalSearch(query, [
    resource.name,
    resource.description,
    resource.location,
    ...choices.filter((choice) => choice.service.resources.some((item) => item.uuid === resource.uuid))
      .flatMap((choice) => [choice.service.name, choice.service.description]),
  ]);
}
